module.exports = __webpack_public_path__ + "static/media/userPermissionActive.e4879214.svg";